// extracted by mini-css-extract-plugin
export var dividerContainer = "_6g-0";
export var line = "_6g-1";